import * as React from 'react';
import 'classnames';
import '@grandvisionhq/forms';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/state';
import '@grandvisionhq/analytics';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import '../../../../../types/product.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import '@swc/helpers';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/elements';
import '@grandvisionhq/inventory';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/common';
import '../../../../VTO/context/VtoProvider.js';
import 'usehooks-ts';
import '@grandvisionhq/icons';
import { OfferingsListContainer } from '../../../components/OfferingsList/OfferingsListContainer.js';
import 'use-onclickoutside';
import '@grandvisionhq/carts-v2';
import '../../../../../hooks/use-product-view-history.js';
import '../../../../../slots/context.js';
import '@grandvisionhq/content';
import { useFramesEcommContext } from '../../context/FramesEcommContext.js';

const FramesOfferingsList = ()=>{
    const { offerings , selectedOffering , setSelectedOffering  } = useFramesEcommContext();
    if (!selectedOffering) return null;
    return /*#__PURE__*/ React.createElement(OfferingsListContainer, {
        offerings: offerings,
        selectedValue: selectedOffering,
        onChange: setSelectedOffering
    });
};

export { FramesOfferingsList };
//# sourceMappingURL=FramesOfferingsList.js.map
